"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function safeParse(json) {
    try {
        return JSON.parse(json);
    }
    catch (e) {
        return null;
    }
}
exports.safeParse = safeParse;
